import { render } from "./B2bTableMenuRecadvsReceived.vue?vue&type=template&id=1b4ca41c&scoped=true&lang=pug"
import script from "./B2bTableMenuRecadvsReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuRecadvsReceived.vue?vue&type=script&lang=js"

import "./B2bTableMenuRecadvsReceived.vue?vue&type=style&index=0&id=1b4ca41c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4ca41c"]])

export default __exports__